import { FC } from 'react'
import Register from "./register";

type Props = {
  renderForm: () => any
  content: GiftContent
}

export type GiftContent = {
  video_link: string;
  video_title: string;
  disclaimer: string
  title: string
  sub_title: string
  text: string
}

const Shared: FC<Props> = ({ renderForm, content }) => {
  return (
    <>
      <Register content={content} renderForm={renderForm} />
    </>
  )
}

export default Shared

